// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Mixin from './mixins/page-mixer.js';
import config from './config'
import store from '@/store'
import http from './api/http'
import publicUi from "@/components/publicUi";
import i18n from './lang/index.js' // 引入中英文语言翻译文件
//import 'swiper/swiper-bundle.css'
import 'swiper/css/swiper.min.css'  
import '@/assets/css/style.css'
import regions from '@/lang/regions'
import Vuex from 'vuex'
import empty from '@/assets/img/empty.png'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import BaiduMap from 'vue-baidu-map'
 import {VueMasonryPlugin} from 'vue-masonry';
Vue.use(VueMasonryPlugin) 

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: '5XmZsGczIV4TlrWbOLceCyqh3eW0sTbL'
})

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBJ1BQM4GgC0Npy0Q-XvugTW0qH1Wkgw7I',
    libraries: 'places',
    region: 'VI', // 这个地区自己定
    language: 'en' // 这个语言自己定
  },
  installComponents: true

})
Vue.use(Vuex)



Vue.config.productionTip = false
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
Vue.prototype.$regions = regions
Vue.use(preview)


Vue.use(publicUi)
Vue.mixin(Mixin);
/* eslint-disable no-new */
var vue=new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App},
  template: '<App/>'
})
Vue.prototype.$empty = empty;
Vue.prototype.http = http;
Vue.prototype.http.init(vue);
Vue.prototype.$EventBus=new Vue();//Vue.js事件总线,用于组件或页面间的通信



// WEBPACK FOOTER //
// ./src/main.js